import { render, staticRenderFns } from "./TournamentBasicInfo.vue?vue&type=template&id=d11f65e6"
import script from "./TournamentBasicInfo.vue?vue&type=script&lang=js"
export * from "./TournamentBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./TournamentBasicInfo.vue?vue&type=style&index=0&id=d11f65e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports